import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "../config/firebase";
import type { TargetType } from "../types";

async function call<T>(name: string, data: Record<string, unknown>): Promise<T> {
  if (!cloudFunctions) throw new Error("Community service is unavailable.");
  return (await httpsCallable<Record<string, unknown>, T>(cloudFunctions, name)(data)).data;
}

export const toggleFollowing = (targetId: string) =>
  call<{ following: boolean; followerCount: number }>("toggleFollowing", { targetId });
export const rateMap = (mapId: string, rating: number, userName: string) =>
  call<{ userRating: number; ratingSum: number; ratingCount: number; averageRating: number }>("rateMap", { mapId, rating, userName });
export const toggleLike = (targetType: TargetType, targetId: string) =>
  call<{ liked: boolean; likeCount: number }>("toggleLike", { targetType, targetId });
export const addComment = (targetType: TargetType, targetId: string, content: string, userName: string) =>
  call<{ commentId: string }>("addComment", { targetType, targetId, content, userName });
export const recordCommunityPlay = (targetType: TargetType, targetId: string) =>
  call<{ playCount: number }>("recordCommunityPlay", { targetType, targetId });
